{ "id": "anneau-bouze", "name": "Anneau de Bouze le Clerc", "slot": "anneau", "set": "bouftou", "tier": 2, "price": 90, "icon": "icons/items/anneau-bouze", "stats": { "vitalite": 30 } }
